import React from "react";
import Seo from "../components/Seo";
import "../styles/pages/contact.css";

function Contact() {
    return (
        <main className="page">
            <Seo
                title="Contact Us"
                path="/contact"
                description="Contact Dahlia Health Care Services to discuss recruitment, care packages, staff training, children's services, and secure transport support."
                keywords="contact health care provider, staffing enquiry, care services contact, secure transport enquiry"
            />

            <div className="container">
                <div className="page-header">
                    <p className="eyebrow">Contact Us</p>
                    <h1>Let’s talk about the support you need</h1>
                    <p>
                        Speak with our team about recruitment, care packages, specialist training, children’s services, or secure transport arrangements.
                    </p>
                </div>

                <div className="contact-layout">
                    <div className="contact-card contact-card--form">
                        <h2>Send an Enquiry</h2>
                        <p className="contact-card__intro">Tell us a little about your requirements and our team will get back to you.</p>
                        <form className="contact-form">
                            <input type="text" placeholder="Full Name" />
                            <input type="email" placeholder="Email Address" />
                            <input type="text" placeholder="Phone Number" />
                            <select>
                                <option>Select Service</option>
                                <option>Staff Recruitment & Supply</option>
                                <option>Mental Health Staff Training</option>
                                <option>Domiciliary Care Including Live-In</option>
                                <option>Children’s Services</option>
                                <option>Secure Transport Services</option>
                            </select>
                            <textarea rows="6" placeholder="Tell us how we can help"></textarea>
                            <button type="submit" className="btn btn--primary">Submit Enquiry</button>
                        </form>
                    </div>

                    <div className="contact-side">
                        <div className="contact-card contact-card--image">
                            <img
                                className="contact-card__image"
                                src="/images/age-2.jpg"
                                alt="Support and care consultation"
                            />
                        </div>
                        <div className="contact-card">
                            <h2>Contact Details</h2>
                            <ul className="contact-list">
                                <li><strong>Phone</strong><span>+44 0207 000000</span></li>
                                <li><strong>Email</strong><span>info@dahlia-healthcareservices.co.uk</span></li>
                                <li><strong>Location</strong><span>Your Business Address, United Kingdom</span></li>
                                <li><strong>Hours</strong><span>Mon - Fri: 9:00 AM - 5:00 PM</span></li>
                            </ul>
                        </div>

                        <div className="contact-banner">
                            <p className="eyebrow eyebrow--light">Need a fast response?</p>
                            <h2>Urgent support requests</h2>
                            <p>
                                For urgent staffing requirements or time-sensitive service requests, contact our team directly and we will respond as quickly as possible.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Contact;